// extracted by mini-css-extract-plugin
export default {"badge":"NewBadge_badge__VgkJX","badgeAnimated":"NewBadge_badgeAnimated__XXU7w","newBadgePulse":"NewBadge_newBadgePulse__dqqtw"};